/* global axios */
import ApiClient from './ApiClient';

class Ga4API extends ApiClient {
  constructor() {
    super('ga4/configs', { accountScoped: true });
  }

  getConfigs() {
    return axios.get(this.url);
  }

  createConfig(payload) {
    return axios.post(this.url, { ga4_config: payload });
  }

  updateConfig(id, payload) {
    return axios.patch(`${this.url}/${id}`, { ga4_config: payload });
  }

  deleteConfig(id) {
    return axios.delete(`${this.url}/${id}`);
  }

  properties(connectionId) {
    return axios.get(`${this.baseUrl()}/ga4/reports/properties`, {
      params: { connection_id: connectionId },
    });
  }

  // range { since, until } em YYYY-MM-DD (periodo da barra de contexto).
  // Sem connectionId/propertyId, o backend AGREGA todas as propriedades
  // marcadas na config. Devolve { data, totals, accounts }.
  report(connectionId, propertyId, range = {}) {
    const params = { since: range.since, until: range.until };
    if (connectionId) params.connection_id = connectionId;
    if (propertyId) params.property_id = propertyId;
    return axios.get(`${this.baseUrl()}/ga4/reports`, { params });
  }
}

export default new Ga4API();
